<div
  class="container"
  fxLayout="row"
  fxLayoutAlign="space-between"
  fxLayoutGap.lt-md="4%"
  fxLayout.lt-md="column"
  matomoForm="view-audit-trail"
  (click)="onAuditDetailsView()"
>
  <div fxFlex="46%">
    <mat-card matomoClick="view-audit-details-card">
      <mat-card-content>
        <div fxLayout="row wrap" class="content">
          <div fxFlex="50%" class="mat-body-strong">ID</div>

          <div fxFlex="50%">
            {{ auditTrailData.id }}
          </div>

          <div fxFlex="50%" class="mat-body-strong">Status</div>

          <div fxFlex="50%">
            {{ auditTrailData.processingResult }}
          </div>

          <div fxFlex="50%" class="mat-body-strong">User</div>

          <div
            fxFlex="50%"
            matomoClick="view-audit-user-email"
            (click)="onUserEmailView()"
          >
            {{ auditTrailData.maker.email }}
          </div>

          <div fxFlex="50%" class="mat-body-strong">Action</div>

          <div fxFlex="50%">
            {{ auditTrailData.actionName }}
          </div>

          <div fxFlex="50%" class="mat-body-strong">Entity</div>

          <div fxFlex="50%">
            {{ auditTrailData.entityName }}
          </div>

          <div fxFlex="50%" class="mat-body-strong">Resource ID</div>

          <div
            fxFlex="50%"
            matomoClick="view-audit-resource-id"
            (click)="onResourceIdView()"
          >
            {{ auditTrailData.resourceId }}
          </div>

          <div fxFlex="50%" class="mat-body-strong">Date</div>

          <div
            fxFlex="50%"
            matomoClick="view-audit-date"
            (click)="onDateView()"
          >
            {{ auditTrailData.madeOnDate | date }}
          </div>

          <div
            fxFlex="50%"
            class="mat-body-strong"
            *ngIf="auditTrailData.officeName"
          >
            Office
          </div>

          <div fxFlex="50%" *ngIf="auditTrailData.officeName">
            {{ auditTrailData.officeName }}
          </div>

          <div
            fxFlex="50%"
            class="mat-body-strong"
            *ngIf="auditTrailData.savingsAccountNo"
          >
            Savings Account No
          </div>

          <div fxFlex="50%" *ngIf="auditTrailData.savingsAccountNo">
            {{ auditTrailData.savingsAccountNo }}
          </div>

          <div
            fxFlex="50%"
            class="mat-body-strong"
            *ngIf="auditTrailData.groupLevelName"
          >
            Group Level
          </div>

          <div fxFlex="50%" *ngIf="auditTrailData.groupLevelName">
            {{ auditTrailData.groupLevelName }}
          </div>
        </div>
      </mat-card-content>
    </mat-card>
  </div>

  <div
    fxFlex="46%"
    matomoClick="view-audit-command-table-container"
    (click)="onCommandTableView()"
  >
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="command">
        <th
          mat-header-cell
          *matHeaderCellDef
          mat-sort-header
          matomoClick="view-audit-command-sort"
          (click)="onTableSort('command')"
        >
          Command
        </th>
        <td mat-cell *matCellDef="let auditTrailCommand">
          {{ auditTrailCommand.command }}
        </td>
      </ng-container>

      <ng-container matColumnDef="commandValue">
        <th
          mat-header-cell
          *matHeaderCellDef
          matomoClick="view-audit-command-value-header"
        >
          Command Value
        </th>
        <td
          mat-cell
          *matCellDef="let auditTrailCommand"
          class="column-value-wrapper"
          matomoClick="view-audit-command-value-cell"
          (click)="onCommandValueView(auditTrailCommand.command)"
        >
          {{ auditTrailCommand.commandValue }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>
</div>
